import script from "./FakeInput.vue?vue&type=script&setup=true&lang=js"
export * from "./FakeInput.vue?vue&type=script&setup=true&lang=js"

import "./FakeInput.vue?vue&type=style&index=0&id=cf96e3de&scoped=true&lang=css"

import exportComponent from "/home/lucas/projects/distrisuper/pc-21/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf96e3de"]])

export default __exports__